module.exports = __webpack_public_path__ + "img/error-dark.f90333fc.svg";